import template from "./markdown.html";
import "./markdown.less";
import marked from "marked";

export class Controller {
	selection = {};

	constructor($sce) {
		this.$sce = $sce;
	}

	$onInit() {
		this._unregister = this.reportFormCtrl.registerFieldController(this);

		this.message = this.$sce.trustAsHtml(marked(this.field.Description));
	}

	getCurrentValue() {
		return [];
	}
}

export default angular
	.module("vesl.components.report-form.markdown", [])
	.component("markdown", {
		template,
		controller: Controller,
		bindings: {
			field: "<",
			values: "<",
			setFieldDirty: "="
		},
		require: {
			reportFormCtrl: "^reportForm"
		}
	}).name;
